import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactFormHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex items-center justify-center mb-4">
        <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
          <Icon name="Phone" size={32} color="var(--color-primary)" strokeWidth={2} />
        </div>
      </div>
      
      <h1 className="text-2xl md:text-3xl font-semibold text-text-primary font-inter mb-3">
        Informations de contact
      </h1>
      
      <p className="text-text-secondary font-inter text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Veuillez nous indiquer vos informations personnelles<br />pour&nbsp;démarrer votre vérification d'identité.
      </p>
    </div>
  );
};

export default ContactFormHeader;